import { PaymentPlan, legacyPricingKeys, PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { BillingFrequency } from 'components/Paywall/UpgradePlanModal/UpgradePlanModal'
import { StripePrice } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'

export const pricePerMonth = (paymentPlan: PaymentPlan, billingFrequency: BillingFrequency) => {
  if (billingFrequency === 'year') {
    const { unit_amount: yearly_amount, amount_off: yearly_amount_off } = paymentPlan.price.year

    return (yearly_amount - (yearly_amount_off || 0)) / 12
  }

  const { unit_amount: monthly_amount, amount_off: monthly_amount_off } = paymentPlan.price.month

  return monthly_amount - (monthly_amount_off || 0)
}

export const totalPrice = (paymentPlan: PaymentPlan, billingFrequency: BillingFrequency, members_count: number) => {
  const isLegacyPlan = legacyPricingKeys.includes(paymentPlan.key)

  if (billingFrequency === 'year') {
    const { unit_amount, amount_off } = paymentPlan.price.year

    if (isLegacyPlan) return unit_amount * members_count

    return unit_amount - (amount_off || 0)
  }

  const monthly = pricePerMonth(paymentPlan, billingFrequency)

  if (isLegacyPlan) return monthly * members_count

  return monthly
}

export const formatPrice = (price?: number) => {
  if (price === null || price === undefined) return ''
  const formatted = Number(price).toFixed(2)
  return formatted.replace(/\.00$/, '')
}

/**
 * Calculates the extra account charges for a given interval count
 * @param currentSubscription - The current subscription object
 * @param intervalCount - The billing interval count (1 for monthly, 3 for quarterly, etc.)
 * @returns The total extra account charges for the interval (in dollars, not cents)
 */
export const calculateExtraAccountCharges = (currentSubscription: any, intervalCount: number) => {
  if (!currentSubscription?.subscription_items) {
    return 0
  }

  const extraAccountItem = currentSubscription.subscription_items.find(
    (item: any) => item.plan_key === PaymentPlanKey.BlazeAutopilotExtraAccounts,
  )

  if (!extraAccountItem) {
    return 0
  }

  const extraAccountPrice = currentSubscription.prices.find((p: StripePrice) => p.id === extraAccountItem.price_id)

  if (!extraAccountPrice) {
    return 0
  }

  // Calculate the cost per month, then multiply by the interval
  const costPerMonth =
    (extraAccountPrice.unit_amount * extraAccountItem.quantity) / extraAccountPrice.recurring.interval_count / 100
  return costPerMonth * intervalCount
}

/**
 * Calculates the monthly extra account charges
 * @param currentSubscription - The current subscription object
 * @returns The monthly extra account charges (in dollars, not cents)
 */
export const calculateMonthlyExtraAccountCharges = (currentSubscription: any) => {
  return calculateExtraAccountCharges(currentSubscription, 1)
}
